import { Button, Form, Input, Radio, Select, Space } from 'antd';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';

export const reasonOptions = [
  'Unit price change',
  'Item(s) discontinued',
  'Item(s) out of stock',
  'Incurrence of additional charges',
  'Request for cancellation by buyer',
  'Others',
];
const OrderRejectionForm = ({
  onSubmit,
  defaultValue = undefined,
  spidData = undefined,
}: {
  onSubmit: (values: any) => void;
  defaultValue?: any;
  spidData?: Array<{ id: number }>;
}) => {
  const hasSpidData = spidData && spidData.length > 0;

  let reason = defaultValue ? defaultValue.reason : undefined;
  const spid_number = hasSpidData
    ? spidData.map(s => String(s.id))
    : defaultValue && defaultValue.supplier_payment
    ? defaultValue.supplier_payment.map(s => String(s.id))
    : [];
  let other_reason = false;
  let reason_select = reason;

  if (
    defaultValue &&
    !reasonOptions.filter(option => option !== 'Others').includes(defaultValue)
  ) {
    other_reason = true;
    reason_select = 'Others';
  }

  const [isSPIDCreated, setIsSPIDCreated] = useState(!!spid_number.length);
  const validationSchema = Yup.object({
    is_spid_created: Yup.boolean().required('Please select Yes/No option!'),
    spid_number: isSPIDCreated
      ? Yup.string().required('SPID Number is Required!')
      : Yup.string().notRequired(),
  });
  const formik = useFormik({
    initialValues: {
      reason,
      other_reason,
      reason_select,
      is_spid_created: !!spid_number.length, // boolean
      spid_number,
    },
    validationSchema,
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: false,
    onSubmit: values => {
      onSubmit(values);
    },
  });

  const getValidateStatus = key => {
    if (formik?.touched[key] && formik.errors[key]) {
      return 'error';
    } else if (formik.values[key]) {
      return 'success';
    } else {
      return '';
    }
  };

  const getHelperText = key => {
    if (formik?.touched[key] && formik.errors[key]) {
      return formik.errors[key];
    }
    return null;
  };

  return (
    <Wrapper>
      <form onSubmit={formik.handleSubmit}>
        <Form.Item
          label="Reasons for PO cancellation"
          validateStatus={getValidateStatus('reason')}
          help={getHelperText('reason')}
          required
        >
          <Radio.Group
            onChange={(evt: any) => {
              const reason = evt?.target?.value;
              if (reason === 'Others') {
                formik.setFieldValue('other_reason', true);
                formik.setFieldValue('reason', '');
              } else {
                formik.setFieldValue('other_reason', false);
                formik.setFieldValue('reason', evt?.target?.value);
              }
              formik.setFieldValue('reason_select', evt?.target?.value);
            }}
            value={formik.values?.reason_select}
          >
            <Space direction="vertical">
              {reasonOptions.map(reason => (
                <Radio value={reason}>{reason}</Radio>
              ))}
            </Space>
          </Radio.Group>
          <Input.TextArea
            style={{ marginTop: 10 }}
            rows={4}
            name="reason"
            value={formik.values?.reason}
            placeholder="Enter Reason"
            onChange={formik.handleChange}
            disabled={!formik.values?.other_reason}
          />
        </Form.Item>

        <Form.Item
          label="Is SPID created?"
          validateStatus={getValidateStatus('is_spid_created')}
          help={
            hasSpidData
              ? 'Auto-populated from linked Supplier Payments.'
              : getHelperText('is_spid_created')
          }
          required
        >
          <Radio.Group
            onChange={(evt: any) => {
              formik.setFieldValue('is_spid_created', evt?.target?.value);
              setIsSPIDCreated(evt?.target?.value);
            }}
            value={formik.values?.is_spid_created}
            disabled={hasSpidData}
          >
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>

        {isSPIDCreated && (
          <Form.Item
            label="SPID Number"
            validateStatus={getValidateStatus('spid_number')}
            help={
              hasSpidData
                ? 'Auto-populated from linked Supplier Payments.'
                : getHelperText('spid_number')
            }
            required
          >
            <Select
              mode="tags"
              style={{ width: '100%' }}
              onChange={value => formik.setFieldValue('spid_number', value)}
              tokenSeparators={[',']}
              value={formik.values.spid_number}
              disabled={hasSpidData}
            />
          </Form.Item>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </div>
      </form>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  max-width: 500px;
  .ant-row {
    flex-direction: column;
  }
  .ant-form-item-label {
    text-align: left !important;
  }
  .ant-form-item {
    margin-bottom: 8px !important;
  }
`;
export default OrderRejectionForm;
